import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, Autoplay } from "swiper";
import 'swiper/css';
import "swiper/css/scrollbar";
import "swiper/css/navigation";
import "swiper/css/pagination";
import ItemNota from '../ItemNota';

type CarouselDeNotasProps = {
    data: any[]
    autoplay?: any
    spaceBetween?: number
    slidesPerView?: number
    slidesPerGroup?: number
    loop?: boolean
    navigation?: boolean
    scrollbar?: any
    pagination?: any
}

const CarouselDeNotas = (props: CarouselDeNotasProps) => {

  const notas = props.data;

  return (<>
    <Swiper
      modules={[Navigation, Pagination, Scrollbar, Autoplay]}
      autoplay={props.autoplay}
      spaceBetween={props.spaceBetween}
      slidesPerView={props.slidesPerView}
      slidesPerGroup={props.slidesPerGroup}
      loop={props.loop}
      navigation={props.navigation}
      scrollbar={props.scrollbar}
      pagination={props.pagination}
    >
      {notas?.map((nota: any) => (
        <SwiperSlide key={nota.id}>
          <ItemNota data={nota} isCarousel={true} />
        </SwiperSlide>
      ))}
    </Swiper>
  </>);
};

export default CarouselDeNotas;
